// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"169":"fbbb86b0","245":"496644a2","419":"8167c9c9","445":"2a515305","648":"25d9d57e","854":"71360094"}[chunkId] + ".chunk.js";
};